import { c as _c } from "react/compiler-runtime";
import { Skeleton } from "@flat-ui";
import { GroupCardBottom } from "@components/group-card/group-card-bottom";
import { Box } from "@mui-wrapper";
import { cardProperties } from "@utils/ui-utils";
import { useMemo } from "react";
import { IMAGE_HEIGHT } from "@components/common/faro-card/faro-card-image";

/** Height of the group skeleton's middle section, with the date and the name */
const cardMiddleHeight = "90px";
/**
 * A skeleton loading for a series of cards
 */
export function CardSkeleton(t0) {
  const $ = _c(28);
  const {
    type
  } = t0;
  let t1;
  bb0: {
    if (type === "project") {
      let t2;
      if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
          shouldShowSubtitle1: true,
          shouldShowSubtitle2: true,
          shouldShowSubtitle3: true,
          shouldShowSubtitle4: true,
          subtitle2PaddingTop: cardProperties.creationDatePaddingTop,
          subtitle1Height: IMAGE_HEIGHT
        };
        $[0] = t2;
      } else {
        t2 = $[0];
      }
      t1 = t2;
      break bb0;
    }
    if (type === "group") {
      let t2;
      if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
          shouldShowSubtitle1: true,
          shouldShowSubtitle2: true,
          shouldShowSubtitle3: true,
          shouldShowSubtitle4: false,
          shouldShowGroupCardBottom: true,
          subtitle2PaddingTop: cardProperties.creationDatePaddingTop,
          subtitle1Height: IMAGE_HEIGHT,
          cardMiddlePaddingTop: "10px",
          cardMiddleHeight
        };
        $[1] = t2;
      } else {
        t2 = $[1];
      }
      t1 = t2;
      break bb0;
    }
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = {};
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    t1 = t2;
  }
  const properties = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      width: "100%",
      height: cardProperties.height,
      boxShadow: cardProperties.boxShadow,
      border: "none",
      borderRadius: cardProperties.borderRadius,
      mt: cardProperties.marginTop
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== properties.shouldShowSubtitle1 || $[5] !== properties.subtitle1Height) {
    t3 = properties.shouldShowSubtitle1 && <Skeleton variant="rectangular" sx={{
      width: "100%",
      height: properties.subtitle1Height
    }} />;
    $[4] = properties.shouldShowSubtitle1;
    $[5] = properties.subtitle1Height;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== properties.cardMiddleHeight || $[8] !== properties.cardMiddlePaddingTop) {
    t4 = {
      height: properties.cardMiddleHeight,
      paddingTop: properties.cardMiddlePaddingTop
    };
    $[7] = properties.cardMiddleHeight;
    $[8] = properties.cardMiddlePaddingTop;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== properties.shouldShowSubtitle2 || $[11] !== properties.subtitle2PaddingTop) {
    t5 = properties.shouldShowSubtitle2 && <Skeleton variant="rectangular" sx={{
      width: "50%",
      height: "14px",
      marginTop: properties.subtitle2PaddingTop,
      ml: "14px"
    }} />;
    $[10] = properties.shouldShowSubtitle2;
    $[11] = properties.subtitle2PaddingTop;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== properties.shouldShowSubtitle3) {
    t6 = properties.shouldShowSubtitle3 && <Skeleton variant="rectangular" sx={{
      width: "60%",
      height: "22px",
      mt: "6px",
      ml: "14px"
    }} />;
    $[13] = properties.shouldShowSubtitle3;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== properties.shouldShowSubtitle4) {
    t7 = properties.shouldShowSubtitle4 && <Skeleton variant="rectangular" sx={{
      width: "30%",
      height: "14px",
      mt: "50px",
      ml: "14px"
    }} />;
    $[15] = properties.shouldShowSubtitle4;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t4 || $[18] !== t5 || $[19] !== t6 || $[20] !== t7) {
    t8 = <Box component="div" sx={t4}>{t5}{t6}{t7}</Box>;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== properties.shouldShowGroupCardBottom) {
    t9 = properties.shouldShowGroupCardBottom && <Box sx={{
      paddingX: "14px",
      marginBottom: "17px"
    }}><GroupCardBottom isLoading={true} /></Box>;
    $[22] = properties.shouldShowGroupCardBottom;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t3 || $[25] !== t8 || $[26] !== t9) {
    t10 = <Box component="div" sx={t2}>{t3}{t8}{t9}</Box>;
    $[24] = t3;
    $[25] = t8;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  return t10;
}